<template>
  <div>
    <b-row class="page-header">
      <b-col class="sm-12">
        <h1>Project Backlog</h1>
      </b-col>
    </b-row>
    <new-task @addTask="addTask($event)" props="newTask"></new-task>
    <b-row>
      <b-col>
        <b-button 
          v-b-modal.addTaskModal 
          variant="outline-primary" 
          class="float-left" 
          v-if="!showCompleted">
          <b-icon-plus></b-icon-plus>Add Task
        </b-button>
              </b-col>
        <b-col >
          <b-button 
            @click="displayCompleted" 
            variant="outline-primary" 
            class="float-right" v-if="!showCompleted">Show Completed Tasks
          </b-button>
          <b-button 
            @click="hideCompleted" 
            variant="outline-primary" 
            class="float-right" v-if="showCompleted">Hide Completed Tasks
          </b-button>          
        </b-col>
    </b-row>
    <b-row v-if="showCompleted">
      <b-col>
        <h3>Completed Tasks</h3>
        <backlog :items="completed"></backlog>
      </b-col>
    </b-row>
    <div class="board" v-if="!showCompleted">
      <b-row>
        <b-col md="12" lg="4" v-for="board in tasks" :key="board.status">
          <b-card :title="board.status">
            <b-card-text>
              <draggable v-model="board.items" group="kanban" @end="storeChanges()">
                <b-card v-for="item in board.items" :key="item.taskId" :title="item.title">
                  <b-card-body>
                    <b-card-text>
                      <div class="clearfix" v-if="board.status == 'Needs-Review'">
                        <span class="float-left">
                          <b-button
                            size="sm"
                            variant="primary"
                            @click="completeTask(item.taskId)"
                          >Done</b-button>
                        </span>
                        <span class="float-right">
                          <b-button
                            size="sm"
                            variant="primary"
                            @click="failTask(item.taskId)"
                          >Try Again</b-button>
                        </span>
                      </div>
                      <span class="float-left clearfix">
                        <span variant="danger" v-if="item.failed != null && board.status != 'Needs-Review'">
                          <b>Failed</b>{{item.failed}} by <b>{{item.reviewer}}</b><br>
                        </span>
                        <b>Due Date:</b>
                        {{item.dueDate}}
                      </span>
                      <a
                        herf="#"
                        v-b-toggle="'accordian-'+item.taskId"
                        variant="link"
                        class="float-right"
                        v-if="item.description"
                      >
                        <span>
                          <b>Description</b>
                          <b-icon-chevron-down font-scale="1"></b-icon-chevron-down>
                        </span>
                      </a>
                      <b-collapse
                        :id="'accordian-'+item.taskId"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <p class="float-left">{{item.description}}</p>
                      </b-collapse>
                    </b-card-text>
                  </b-card-body>
                </b-card>
              </draggable>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Backlog from "../components/backlog";
import NewTaskModal from "../components/new_task_modal";
import Draggable from "vuedraggable";
import { mixins } from "../mixins";

export default {
  name: "kanban",
  mixins: [mixins],
  data() {
    return {
      tasks: [],
      newTask: {},
      completed: [],
      showCompleted: false
    };
  },
  components: {
    backlog: Backlog,
    draggable: Draggable,
    "new-task": NewTaskModal
  },
  created() {
    this.loadTasks();
  },
  methods: {
    async displayCompleted() {
      await this.completedTasks();
      this.showCompleted = true;
    },
    hideCompleted() {
      this.showCompleted = false;
    },
    loadTasks() {
      this.api
        .get("/secure/tasks")
        .then(results => {
          this.tasks = results.data;
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    },
    addTask(task) {
      this.api
        .post("/secure/addTask", task)
        .then(() => {
          this.successToast(task.title + " was added");
          this.loadTasks();
          this.task = {};
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    },
    storeChanges() {
      let boards = [];
      this.tasks.forEach(board => {
        let orderedItems = [];
        board.items.forEach(item => {
          orderedItems.push({ taskId: item.taskId, version: item.version });
        });
        boards.push({ status: board.status, items: orderedItems });
      });
      this.api
        .post("/secure/newOrder", { newOrder: boards })
        .then(() => {
          this.successToast("New order was saved!");
          this.loadTasks();
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    },
    failTask(task) {
      this.api
        .post("/secure/failTask", { taskId: task })
        .then(() => {
          this.successToast("Failed Task");
          this.loadTasks();
          this.task = {};
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    },
    completeTask(task) {
      this.api
        .post("/secure/completeTask", { taskId: task })
        .then(() => {
          this.successToast("Completed Task");
          this.loadTasks();
          this.task = {};
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    },
    completedTasks() {
      this.api
        .get("/secure/completedTasks")
        .then(response => {
          this.completed = response.data;
        })
        .catch(error => {
          this.errorToast(error.message || error.response.data.message || "");
        });
    }
  }
};
</script>
<style>
.page-header h1 {
  font-weight: 300;
}
.card {
  margin-bottom: 10px;
}
.card:last-child {
  margin-bottom: 25px;
}
.card-block {
  padding: 15px;
}
</style>